
import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DroneReport } from 'src/app/core/data-models/drone-report.model';
import { DroneReportActionResult, DroneReportService } from 'src/app/core/data-services/drone-report.service';

@Component({
    selector: 'app-drone-report-confirm-modal',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './drone-report-confirm-modal.component.html',
})
export class DroneReportConfirmModalComponent {
    @Input({ required: true}) report!: DroneReport;
    @Input({ required: true }) action!: (report: DroneReport) => Promise<DroneReportActionResult>;

    @Input() title = 'Delete Report';
    @Input() message = 'Are you sure you want to delete this report?';
    @Input() warning = 'This action cannot be undone.';
    @Input() confirmButtonText = 'Delete';
    @Input() buttonLoadingText = 'Deleting...';
    @Input() confirmIcon = 'bi-trash';

    @Output() closed = new EventEmitter<void>();

    readonly reports = inject(DroneReportService);
    loading = signal(false);
    error = signal<string | null>(null);

    async confirm(): Promise<void> {
        this.loading.set(true);
        this.error.set(null);
        try {
            const result = await this.action(this.report);
            if (result.ok) {
                this.closed.emit();
            } else {
                this.error.set(result.error || 'An unknown error occurred.');
            }
        } catch (err) {
            this.error.set((err as Error).message || 'An unknown error occurred.');
        } finally {
            this.loading.set(false);
        }
    }

    cancel(): void {
        if(!this.loading()) {
            this.closed.emit();
        }
    }
}